import { render, staticRenderFns } from "./ManageENS.vue?vue&type=template&id=5977a932&scoped=true&"
import script from "./ManageENS.vue?vue&type=script&lang=js&"
export * from "./ManageENS.vue?vue&type=script&lang=js&"
import style0 from "./ManageENS.vue?vue&type=style&index=0&id=5977a932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5977a932",
  null
  
)

export default component.exports